@use "../../styles/breakpoint.module.scss" as *;

.root {
    --transition-length: 0.7s;
}

.match {
    composes: root;
    composes: match from "../../styles/theming.module.css";
}

.contrast {
    composes: root;
    composes: contrast from "../../styles/theming.module.css";
}

.header {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    align-items: flex-end;
    margin-bottom: var(--spacer-40);
}

.richText {
    grid-column: span 8;

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }
}

.headerCta {
    display: flex;
    justify-content: flex-end;
    grid-column: 10 / span 3;

    @media ($below-laptop) {
        grid-column: 9 / span 4;
    }

    @media ($below-tablet) {
        display: block;
        grid-column: 1 / -1;
    }
}

.inner {
    display: flex;
    gap: 1px;

    @media ($above-tablet) {
        > * {
            flex: 1 1 33%;
            transition: flex-basis var(--transition-length);
        }
    }

    @media ($below-tablet) {
        flex-direction: column;

        > * {
            transition: height var(--transition-length);
        }
    }
}

.innerExpanded {
    composes: inner;

    .blockExpanded {
        @media ($above-tablet) {
            flex: 1 1 60%;
        }

        @media ($below-tablet) {
            height: 380px;
        }

        &::after {
            background: linear-gradient(
                180deg,
                rgb(var(--black-base) / 0%) 0%,
                rgb(var(--black-base) / 60%) 75.45%
            );
        }

        .subtitle {
            height: 100%;
            margin-top: var(--spacer-12);
        }

        .textInner {
            @media ($above-tablet) {
                width: 40vw;
            }
        }

        .arrow {
            scale: -1 1;
        }
    }

    .blockClosed {
        @media ($above-tablet) {
            flex: 1 1 20%;
        }

        .text {
            opacity: 0;
        }
    }
}

.innerNoneExpanded {
    composes: inner;
}

.block {
    composes: dark from "../../styles/theming.module.css";
    composes: outline from "../../styles/composable/utility.module.css";
    position: relative;
    display: flex;
    align-items: flex-end;
    padding: var(--spacer-40);
    min-width: 0;
    overflow: hidden;

    @media ($above-tablet) {
        height: 470px;
    }

    @media ($above-laptop) {
        height: 540px;
    }

    @media ($below-tablet) {
        height: 210px;
    }

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background:
            linear-gradient(
                0deg,
                rgb(var(--black-base) / 60%) 0%,
                rgb(var(--black-base) / 60%) 100%
            ),
            linear-gradient(
                180deg,
                rgb(var(--black-base) / 0%) 0%,
                rgb(var(--black-base) / 60%) 100%
            );
        transition: background var(--transition-length);
    }
}

.blockExpanded,
.blockClosed {
    composes: block;
}

.panel {
    width: 100%;
    content-visibility: visible;
}

.text {
    flex: 1 1 auto;
    margin-bottom: calc(var(--spacer-8) * -1);
    min-width: 0;
    overflow: hidden;
    opacity: 1;
    transition: opacity var(--transition-length);
}

.textInner {
    display: inline-block;

    @media ($above-tablet) {
        width: 22vw;
    }
}

.content {
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: var(--spacer-24);
    width: 100%;
    z-index: 1;
}

.title {
    font: var(--font-h-24);
}

.subtitle {
    display: block;
    height: 0;
    margin-top: 0;
    overflow: hidden;
}

.arrow {
    display: block;
    flex-shrink: 0;
    width: var(--spacer-24);
    height: auto;
    fill: currentColor;
    scale: 1 1;
    transition: scale var(--transition-length);
}

.mediaWrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    & :is(img, video) {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
}

.videoControls {
    bottom: unset;
    top: var(--spacer-24);
}

.trigger {
    composes: buttonReset from "../../styles/composable/utility.module.css";
    composes: outline from "../../styles/composable/utility.module.css";
    z-index: 2;
    position: absolute;
    inset: 10px;
}
